import { Badge } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { BadgeProps } from "@chakra-ui/layout/src/badge";

import { getUtilisationLevelColor } from "@tether-web-portal/components/occupancy/occupancy.colors";
import { getUtilisationLevel } from "@tether-web-portal/occupancy/utilisationLevel";
import { asPercent0100, percentToFraction } from "@tether-web-portal/occupancy/units";
import { OccupancyUtilisationLevels } from "@tether-web-portal/web-workers/occupancy/types/OccupancyUtilisation";

interface StatusBadgeProps extends BadgeProps {
  /** Percentage in 0..100 range. Kept as a plain number for caller convenience. */
  value: number;
}

const LEVEL_LABEL: Record<OccupancyUtilisationLevels, string> = {
  [OccupancyUtilisationLevels.LOW]: "Low",
  [OccupancyUtilisationLevels.OPTIMAL]: "Optimal",
  [OccupancyUtilisationLevels.OVER]: "Over",
};

export const OccupancyStatusBadge = ({ value, ...props }: StatusBadgeProps) => {
  const { color, label } = useMemo(() => {
    const level = getUtilisationLevel(percentToFraction(asPercent0100(value)));
    return {
      color: getUtilisationLevelColor(level),
      label: LEVEL_LABEL[level],
    };
  }, [value]);

  return (
    <Badge
      {...props}
      bg={color}
      fontSize={props?.fontSize ?? "xl"}
      textTransform="none"
      color="white"
      mt={1}
      mb={2}
      px={2.5}
      py={1}
      borderRadius={"3xl"}
    >
      {label}
    </Badge>
  );
};
